import type { FaireAdvertiserProfileEntity } from "../../entity_types/advertiserProfile";

// Sweet on Vermont Artisan Confections (b_7ywxs1y6xb, advertiser
// 1227933197552505371). Lifetime complete-month metrics through Aug 2026.
export const advSweetOnVermont: FaireAdvertiserProfileEntity = {
  token: "adv_sweet_on_vermont",
  type: "advertiserProfile",
  archetype: "floor-budget-tiny-results",
  displayName: "Sweet on Vermont",
  brandToken: "b_7ywxs1y6xb",
  audienceType: "NEW_AND_RETURNING",
  globalStatus: "ACTIVE",
  tenureMonths: 30,
  budget: {
    totalBudgetDollars: 200,
    sharedBudgetDollars: 200,
    spendingMode: "MODERATE",
    nextRenewsAtDate: "2026-10-01",
    nextBillsAtDate: "2026-10-04",
  },
  overview: {
    numCustomersAcquired: 50,
    numReorderConversions: 4,
    numTotalConversions: 54,
    totalAdsSalesDollars: 26296,
    newCustomerAdsSalesDollars: 24672,
    reorderAdsSalesDollars: 1624,
    totalAdsSpendDollars: 3416,
    newCustomerAdsSpendDollars: 3301,
    reorderAdsSpendDollars: 115,
    newCustomerBestEstimateFirstYearRoas: 6.86,
    reorderRoas: 14.12,
    combinedFirstYearRoas: 7.11,
    numNewCustomerAdsOrders: 101,
    numReorderAdsOrders: 6,
  },
  availableCredit: { totalRemainingDollars: 0 },
  budgetRecommendations: {
    newCustomer: {
      minRecommendedBudgetDollars: 300,
      maxRecommendedBudgetDollars: 600,
      isEligibleForIncreaseRec: true,
    },
    reorder: {
      minRecommendedBudgetDollars: 100,
      maxRecommendedBudgetDollars: 200,
      isEligibleForIncreaseRec: false,
    },
  },
  campaignTokens: ["camp_sov_new", "camp_sov_reorder"],
  overviewPerformancePeriodTokens: [],
  meta: {
    source: "snowflake",
    importedAt: "2026-09-27T00:00:00.000Z",
    importedBy: "real-brand-data",
  },
};
